import { Modal } from "@woodmac-hycb/modal";
import { Text } from "@woodmac-hycb/text";

function ErrorModal({ isOpen, onClose, errorMessage }) {
    return (
        <Modal
            open={isOpen}
            dismissable
            onCancel={onClose}
            title="Communication Error"
        >
            <Text>{errorMessage}</Text>
        </Modal>
    )
} export default ErrorModal;